module.exports = __webpack_public_path__ + "img/travelpoint.daa2220a.png";